<template>
  <div class="">
    <el-form
      class="add-form"
      @submit.prevent="checkContractInformation"
      @keydown.enter.prevent="() => {}"
      :model="contract"
      label-position="top"
      ref="contractForm"
    >
      <div class="form-group-wrapper">
        <!-- Name - Description-->

        <!-- Organization -->
        <div class="form-wrapper full">
          <el-form-item
            prop="organization.id"
            :rules="[
              {
                required: true,
                message: $t('COMMON.ORGANIZATION_REQUIRED'),
              },
            ]"
          >
            <base-input
              :label="`${$t('COMMON.ORGANIZATION')} (*)`"
              :placeholder="$t('COMMON.ORGANIZATION')"
              v-if="
                $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS) &&
                !hideOrganization
              "
            >
              <organization-selector
                :organization="contract.organization.id"
                :filterable="true"
                :showAll="false"
                @organizationChanged="
                  (organizationId) => {
                    contract.organization.id = organizationId;
                    onFormChanged();
                    openOrCloseModelSelector();
                  }
                "
                :disabled="!!contract.id"
              />
            </base-input>
            <validation-error :errors="apiValidationErrors.organization" />
          </el-form-item>
        </div>

        <div class="form-wrapper full my-2">
          <el-checkbox
            :disabled="disableTemplateSelection"
            @input="openOrCloseModelSelector"
            v-model="fromModel"
            >{{ $t("SIGNATURES.CLONE_MODEL") }}</el-checkbox
          >
        </div>
        <div v-if="fromModel" class="form-group-wrapper form-model w-100">
          <!-- Sélectionner le contrat -->
          <el-form-item
            class="form-group-wrapper-item w-100"
            :label="`${$t('SIGNATURES.SELECT_MODEL')}`"
            prop="model_id"
            :rules="[
              {
                required: true,
                message: $t('SIGNATURES.MODEL_REQUIRED'),
              },
            ]"
          >
            <contract-selector
              :contract="contract.model_id?.toString()"
              :filterable="true"
              :showAll="false"
              :allowCreate="false"
              :filterOrganization="contract.organization.id"
              :disabled="disableTemplateSelection"
              @contractChanged="contractSelected"
            />
            <validation-error :errors="apiValidationErrors.contract" />
          </el-form-item>
        </div>

        <!-- Name -->
        <el-form-item
          class="form-group-wrapper-item w-100"
          prop="name"
          :rules="[
            {
              required: true,
              message: $t('COMMON.NAME_REQUIRED'),
            },
          ]"
        >
          <base-input
            :label="`${$t('COMMON.NAME')} (*)`"
            :placeholder="$t('COMMON.NAME')"
          >
            <el-input
              :placeholder="$t('COMMON.NAME')"
              v-model="contract.name"
              @change="
                () => {
                  onFormChanged();
                }
              "
            />
          </base-input>
          <validation-error :errors="apiValidationErrors.name" />
        </el-form-item>


        <!-- Roles -->
        <el-form-item
          class="form-group-wrapper-item w-100"
          prop="roles"
          :rules="[
            {
              required: true,
              message: $t('SIGNATURES.ROLES_REQUIRED'),
            },
          ]"
        >
          <base-input
            :label="`${$t('SIGNATURES.ROLES')} (*)`"
            :placeholder="$t('SIGNATURES.ROLES')"
          >
            <el-select
              v-model="contract.roles"
              multiple
              filterable
              allow-create
              default-first-option
              :placeholder="$t('SIGNATURES.ADD_ROLES')"
            >
              <el-option
                v-for="(item, index) in defaultRoles"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </base-input>
          <validation-error :errors="apiValidationErrors.roles" />
        </el-form-item>

    <div class="form-group-wrapper">
        <!-- language -->
        <el-form-item
              class="form-group-wrapper-item"
              :label="$t('CONTRACTS.LANGUAGE')"
              prop="meta.language"
            >
              <el-select
                v-model="contract.meta.language"
                :placeholder="$t('CONTRACTS.LANGUAGE')"
                filterable
              >
                <el-option
                  v-for="lang in onespanLanguages"
                  :key="lang.id"
                  :label="lang.label"
                  :value="lang.id"
                ></el-option>
              </el-select>
          <validation-error :errors="apiValidationErrors?.meta?.language" />
        </el-form-item>
        
        <!-- timezone -->
        <el-form-item
              class="form-group-wrapper-item"
              :label="$t('CONTRACTS.TIMEZONE')"
              prop="meta.timezone"
            >
              <el-select
                v-model="contract.meta.timezone"
                :placeholder="$t('CONTRACTS.TIMEZONE')"
                filterable
              >
                <el-option
                  v-for="tz in onespanTimezones"
                  :key="tz.id"
                  :label="tz.label"
                  :value="tz.id"
                ></el-option>
              </el-select>
          <validation-error :errors="apiValidationErrors?.meta?.timezone" />
        </el-form-item>
    </div>

        <!-- Excerpt -->
        <el-form-item
          class="form-group-wrapper-item"
          :label="`${$t('COMMON.EXCERPT')} (*)`"
          prop="excerpt"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 4 }"
            :placeholder="$t('COMMON.EXCERPT')"
            v-model="contract.excerpt"
          >
          </el-input>
          <validation-error :errors="apiValidationErrors.excerpt" />
        </el-form-item>

        <!-- email_message -->
        <el-form-item
          class="form-group-wrapper-item"
          :label="`${$t('SIGNATURES.EMAIL_MESSAGE')} (*)`"
          prop="email_message"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 4 }"
            :placeholder="$t('SIGNATURES.EMAIL_MESSAGE')"
            v-model="contract.email_message"
          >
          </el-input>
          <validation-error :errors="apiValidationErrors.email_message" />
        </el-form-item>

        <!-- <div class="row">
          <div class="col-md-6">
            <el-form-item
              class="form-group-wrapper-item w-100"
              :label="$t('CONTRACTS.LANGUAGE') || 'Langue'"
              prop="meta.language"
            >
              <el-select
                v-model="contract.meta.language"
                :placeholder="$t('CONTRACTS.LANGUAGE') || 'Langue'"
                filterable
              >
                <el-option
                  v-for="lang in onespanLanguages"
                  :key="lang.id"
                  :label="lang.label"
                  :value="lang.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          
          <div class="col-md-6">
            <el-form-item
              class="form-group-wrapper-item w-100"
              :label="$t('CONTRACTS.TIMEZONE') || 'Fuseau horaire'"
              prop="meta.timezone"
            >
              <el-select
                v-model="contract.meta.timezone"
                :placeholder="$t('CONTRACTS.TIMEZONE') || 'Fuseau horaire'"
                filterable
              >
                <el-option
                  v-for="tz in onespanTimezones"
                  :key="tz.id"
                  :label="tz.label"
                  :value="tz.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div> -->

        <!-- <div class="row">
          <div class="col-md-6 pt-md-2">
            <el-form-item class="form-group-wrapper-item w-100">
              <el-switch
                v-model="contract.meta.enforce_accessibility"
                :active-text="$t('CONTRACTS.ENFORCE_ACCESSIBILITY') || 'Imposer l\'accessibilité du document'"
              ></el-switch>
            </el-form-item>
          </div>
          <div class="col-md-6 pt-md-2">
            <el-form-item class="form-group-wrapper-item w-100">
              <el-switch
                v-model="contract.meta.verify_before_finalize"
                :active-text="$t('CONTRACTS.VERIFY_BEFORE_FINALIZE') || 'Vérifiez avant de finaliser'"
              ></el-switch>
            </el-form-item>
          </div>
        </div> -->

       <!--  <div class="row mt-3">
          <div class="col-12">
            <h5>{{ $t('CONTRACTS.EXPIRATION') || 'Expiration' }}</h5>
          </div>
          <div class="col-md-6 pt-md-2">
            <el-form-item class="form-group-wrapper-item w-100">
              <el-checkbox v-model="contract.meta.indefinite_expiration">{{ $t('CONTRACTS.INDEFINITE_EXPIRATION') || 'Expiration indéfinie' }}</el-checkbox>
            </el-form-item>
          </div>
          <div class="col-md-6" v-if="!contract.meta.indefinite_expiration">
            <el-form-item
              class="form-group-wrapper-item w-100"
              :label="$t('CONTRACTS.EXPIRATION_DATE') || 'Date d\'expiration'"
            >
              <el-date-picker
                v-model="contract.meta.expiration_date"
                type="date"
                :placeholder="$t('CONTRACTS.SELECT_DATE') || 'Sélectionner une date'"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </div>
        </div> -->

        <div class="submit-wrapper mt-4">
          <base-button
            type="button"
            class="btn btn-sm elite-submit"
            native-type="submit"
            @click.prevent="checkContractInformation"
            :disabled="loading || processing"
          >
            <i class="fas fa-spinner fa-spin" v-if="loading || processing" />
            {{
              contract.id
                ? $t("CONTRACTS.EDIT_CONTRACT")
                : $t("CONTRACTS.ADD_CONTRACT")
            }}
          </base-button>
        </div>
      </div>
    </el-form>

    <modal
      :show="showContractCheckModal"
      modal-classes="modal-secondary"
      size="lg"
    >
      <div class="" slot="header">
        <h2 id="">
          {{ $t("COMMON.CONFIRMATION") }}
        </h2>
      </div>
      <div class="">
        <div class="row">
          <p class="text-lg text-center">
            {{
              $t("CONTRACTS.SAME_CONTRACTS", {
                name: contract.name,
              })
            }}
          </p>
        </div>
        <div class="page-wrapper-table-body">
          <div class="page-wrapper-table-body-inner">
            <el-table
              class="align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="contracts"
            >
              <div class="table-loading" slot="empty" v-if="loading">
                <img src="/img/loading.gif" alt="" />
              </div>
              <el-table-column
                :label="$t('COMMON.NAME')"
                min-width="250"
                prop="name"
              >
                <template v-slot="{ row }">
                  <span>
                    {{ `${row.name}` }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('COMMON.EXCERPT')" min-width="300">
                <template v-slot="{ row }">
                  {{ row.excerpt ?? "" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <template slot="footer">
        <button
          type="submit"
          class="btn btn-primary"
          @click="continueFormSubmitProcess"
          :disabled="loading || processing"
        >
          <span v-if="loading || processing" class="btn-inner--icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
          {{ $t("COMMON.CONTINUE") }}
        </button>

        <button
          type="button"
          class="btn btn-link ml-auto"
          @click="toggleContractCheckModalState"
          :disabled="loading || processing"
        >
          {{ $t("COMMON.CANCEL") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
import {
  Option,
  Select,
  Table,
  TableColumn,
  Form,
  FormItem,
  Checkbox,
  Switch,
  DatePicker,
} from "element-ui";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import { CONTRACT_TYPES, DEFAULT_ROLES } from "@/constants/contracts";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import ContractSelector from "../components/ContractSelector.vue";
export default {
  layout: "DashboardLayout",

  components: {
    ValidationError,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [DatePicker.name]: DatePicker,
    OrganizationSelector,
    ContractSelector,
  },

  mixins: [formMixin],

  props: [
    "hideOrganization",
    "contractData",
    "formErrors",
    "loading",
    "hideSubmit",
  ],
  data() {
    let contractData = { ...this.contractData };
    if (!contractData.meta) {
      contractData.meta = {
        language: 'fr',
        timezone: 'GMT',
        //enforce_accessibility: false,
        //verify_before_finalize: false,
        //indefinite_expiration: true,
        //expiration_date: ''
      };
    }
    contractData = this.$fillUserOrganizationData(contractData);
    return {
      usingOneSpanSignatureModel: false,
      disableTemplateSelection: false,
      fromModel: false,
      contract: contractData,
      contracts: [],
      total: 0,
      showModal: false,
      showContractCheckModal: false,
      processing: false,
      CONTRACT_TYPES: CONTRACT_TYPES,
      defaultRoles: DEFAULT_ROLES,
      onespanLanguages: [{"id":"en","label":"Anglais (États-Unis)"},{"id":"da","label":"Danois"},{"id":"de","label":"Allemand"},{"id":"en-GB","label":"Anglais (Royaume-Uni)"},{"id":"es","label":"Espagnol (Amérique latine)"},{"id":"es-ES","label":"Espagnol (Espagne)"},{"id":"fr","label":"Français"},{"id":"it","label":"Italien"},{"id":"nl","label":"Néerlandais"},{"id":"no","label":"Norvégien"},{"id":"pl","label":"Polonais"},{"id":"pt","label":"Portugais"},{"id":"ro","label":"Roumain"},{"id":"bg","label":"Bulgare"},{"id":"ru","label":"Russe"},{"id":"zh-CN","label":"Chinois simplifié"},{"id":"zh-TW","label":"Chinois traditionnel"},{"id":"ja","label":"Japonais"},{"id":"ko","label":"Coréen"},{"id":"el","label":"Grec"},{"id":"ar","label":"Arabe"}],
      onespanTimezones: [{"id":"Etc/GMT+12","label":"(GMT-12:00) Temps moyen de Greenwich -12"},{"id":"Pacific/Samoa","label":"(GMT-11:00) Pacifique/Samoa"},{"id":"US/Samoa","label":"(GMT-11:00) États-Unis/Samoa"},{"id":"HST","label":"(GMT-10:00) Heure standard de Hawaï"},{"id":"Pacific/Honolulu","label":"(GMT-10:00) Pacifique/Honolulu"},{"id":"Pacific/Marquesas","label":"(GMT-9:30) Pacifique/Marquises"},{"id":"Pacific/Gambier","label":"(GMT-9:00) Pacifique/Gambier"},{"id":"US/Alaska","label":"(GMT-9:00) États-Unis/Alaska"},{"id":"America/Los_Angeles","label":"(GMT-8:00) Amérique/Los Angeles"},{"id":"America/Tijuana","label":"(GMT-8:00) Amérique/Tijuana"},{"id":"Canada/Pacific","label":"(GMT-8:00) Canada/Pacifique"},{"id":"PST","label":"(GMT-8:00) Pacifique"},{"id":"America/Vancouver","label":"(GMT-8:00) Amérique/Vancouver"},{"id":"America/Denver","label":"(GMT-7:00) Amérique/Denver"},{"id":"Canada/Mountain","label":"(GMT-7:00) Canada/Montagnes"},{"id":"America/Phoenix","label":"(GMT-7:00) Amérique/Phoenix"},{"id":"CST","label":"(GMT-6:00) Heure standard du Centre"},{"id":"Canada/Central","label":"(GMT-6:00) Canada/Centre"},{"id":"US/Central","label":"(GMT-6:00) États-Unis/Centre"},{"id":"America/Regina","label":"(GMT-6:00) Amérique/Regina"},{"id":"America/Chicago","label":"(GMT-6:00) Amérique/Chicago"},{"id":"Canada/Saskatchewan","label":"(GMT-6:00) Canada/Saskatchewan"},{"id":"America/Bogota","label":"(GMT-5:00) Amérique/Bogota"},{"id":"America/Toronto","label":"(GMT-5:00) Amérique/Toronto"},{"id":"EST","label":"(GMT-5:00) Heure standard de l'Est"},{"id":"US/Eastern","label":"(GMT-5:00) États-Unis/Est"},{"id":"America/Detroit","label":"(GMT-5:00) Amérique/Détroit"},{"id":"America/Jamaica","label":"(GMT-5:00) Amérique/Jamaïque"},{"id":"America/Montreal","label":"(GMT-5:00) Amérique/Montréal"},{"id":"America/Panama","label":"(GMT-5:00) Amérique/Panama"},{"id":"America/Caracas","label":"(GMT-4:30) Amérique/Caracas"},{"id":"America/Puerto_Rico","label":"(GMT-4:00) Amérique/Porto Rico"},{"id":"Canada/Atlantic","label":"(GMT-4:00) Canada/Atlantique"},{"id":"America/Antigua","label":"(GMT-4:00) Amérique/Antigua"},{"id":"America/Barbados","label":"(GMT-4:00) Amérique/Barbade"},{"id":"America/Santiago","label":"(GMT-4:00) Amérique/Santiago"},{"id":"America/St_Johns","label":"(GMT-3:30) Amérique/Saint-Jean de Terre-Neuve"},{"id":"CNT","label":"(GMT-3:30) Heure du Canada et de Terre-Neuve"},{"id":"Canada/Newfoundland","label":"(GMT-3:30) Canada/Terre-Neuve"},{"id":"America/Argentina/Buenos_Aires","label":"(GMT-3:00) Amérique/Argentine/Buenos Aires"},{"id":"Brazil/East","label":"(GMT-3:00) Brésil/Est"},{"id":"Atlantic/South_Georgia","label":"(GMT-2:00) Atlantique/Géorgie du Sud"},{"id":"Brazil/DeNoronha","label":"(GMT-2:00) Brésil/Fernando de Noronha"},{"id":"Atlantic/Azores","label":"(GMT-1:00) Atlantique/Açores"},{"id":"Atlantic/Cape_Verde","label":"(GMT-1:00) Atlantique/Cap-Vert"},{"id":"Africa/Casablanca","label":"(GMT 0:00) Afrique/Casablanca"},{"id":"GMT","label":"(GMT 0:00) Heure de Greenwich"},{"id":"Etc/Greenwich","label":"(GMT 0:00) Greenwich"},{"id":"Europe/London","label":"(GMT 0:00) Europe/Londres"},{"id":"Iceland","label":"(GMT 0:00) Islande"},{"id":"Africa/Lagos","label":"(GMT+1:00) Afrique/Lagos"},{"id":"CET","label":"(GMT+1:00) Heure d'Europe centrale"},{"id":"Europe/Paris","label":"(GMT+1:00) Europe/Paris"},{"id":"Europe/Zurich","label":"(GMT+1:00) Europe/Zurich"},{"id":"Europe/Amsterdam","label":"(GMT+1:00) Europe/Amsterdam"},{"id":"Europe/Madrid","label":"(GMT+1:00) Europe/Madrid"},{"id":"Europe/Copenhagen","label":"(GMT+1:00) Europe/Copenhague"},{"id":"Europe/Prague","label":"(GMT+1:00) Europe/Prague"},{"id":"Europe/Rome","label":"(GMT+1:00) Europe/Rome"},{"id":"Europe/Stockholm","label":"(GMT+1:00) Europe/Stockholm"},{"id":"Europe/Warsaw","label":"(GMT+1:00) Europe/Varsovie"},{"id":"ART","label":"(GMT+2:00) Heure d'Argentine"},{"id":"Africa/Cairo","label":"(GMT+2:00) Afrique/Le Caire"},{"id":"Asia/Istanbul","label":"(GMT+2:00) Asie/Istanbul"},{"id":"Europe/Helsinki","label":"(GMT+2:00) Europe/Helsinki"},{"id":"Africa/Addis_Ababa","label":"(GMT+3:00) Afrique/Addis-Abeba"},{"id":"Africa/Nairobi","label":"(GMT+3:00) Afrique/Nairobi"},{"id":"Asia/Tehran","label":"(GMT+3:30) Asie/Téhéran"},{"id":"Asia/Dubai","label":"(GMT+4:00) Asie/Dubaï"},{"id":"Europe/Moscow","label":"(GMT+4:00) Europe/Moscou"},{"id":"NET","label":"(GMT+4:00) Heure du Proche-Orient"},{"id":"Asia/Kabul","label":"(GMT+4:30) Asie/Kaboul"},{"id":"Asia/Karachi","label":"(GMT+5:00) Asie/Karachi"},{"id":"Asia/Kolkata","label":"(GMT+5:30) Asie/Kolkata"},{"id":"IST","label":"(GMT+5:30) Heure standard d'Inde"},{"id":"Asia/Katmandu","label":"(GMT+5:45) Asie/Katmandou"},{"id":"Asia/Dhaka","label":"(GMT+6:00) Asie/Dhaka"},{"id":"Asia/Rangoon","label":"(GMT+6:30) Asie/Rangoun"},{"id":"Asia/Bangkok","label":"(GMT+7:00) Asie/Bangkok"},{"id":"Asia/Jakarta","label":"(GMT+7:00) Asie/Jakarta"},{"id":"VST","label":"(GMT+7:00) Heure du Vietnam"},{"id":"Asia/Hong_Kong","label":"(GMT+8:00) Asie/Hong Kong"},{"id":"Australia/Perth","label":"(GMT+8:00) Australie/Perth"},{"id":"CTT","label":"(GMT+8:00) Heure standard de Chine"},{"id":"Australia/Eucla","label":"(GMT+8:45) Australie/Eucla"},{"id":"Asia/Seoul","label":"(GMT+9:00) Asie/Séoul"},{"id":"Asia/Tokyo","label":"(GMT+9:00) Asie/Tokyo"},{"id":"JST","label":"(GMT+9:00) Heure standard du Japon"},{"id":"ACT","label":"(GMT+9:30) Heure d'Australie, Centre"},{"id":"Australia/Adelaide","label":"(GMT+9:30) Australie/Adélaïde"},{"id":"Australia/Darwin","label":"(GMT+9:30) Australie/Darwin"},{"id":"AET","label":"(GMT+10:00) Heure d'Australie, Est"},{"id":"Australia/Brisbane","label":"(GMT+10:00) Australie/Brisbane"},{"id":"Australia/Sydney","label":"(GMT+10:00) Australie/Sydney"},{"id":"Australia/Canberra","label":"(GMT+10:00) Australie/Canberra"},{"id":"Australia/LHI","label":"(GMT+10:30) Australie/Île Lord Howe"},{"id":"Australia/Lord_Howe","label":"(GMT+10:30) Australie/Lord Howe"},{"id":"Asia/Vladivostok","label":"(GMT+11:00) Asie/Vladivostok"},{"id":"SST","label":"(GMT+11:00) Heure standard des Samoa"},{"id":"Pacific/Norfolk","label":"(GMT+11:30) Pacifique/Norfolk"},{"id":"Antarctica/South_Pole","label":"(GMT+12:00) Antarctique/Pôle Sud"},{"id":"NST","label":"(GMT+12:00) Heure standard de Terre-Neuve"},{"id":"Pacific/Auckland","label":"(GMT+12:00) Pacifique/Auckland"},{"id":"NZ-CHAT","label":"(GMT+12:45) Nouvelle-Zélande/Chatham"},{"id":"Pacific/Chatham","label":"(GMT+12:45) Pacifique/Chatham"},{"id":"MIT","label":"(GMT+13:00) Heure de l'Île du Millénaire"},{"id":"Pacific/Tongatapu","label":"(GMT+13:00) Pacifique/Tongatapu"},{"id":"Pacific/Kiritimati","label":"(GMT+14:00) Pacifique/Île Christmas"}]
    };
  },

  created() {
    if (this.contract.model_id) {
      this.fromModel = true;
      this.usingOneSpanSignatureModel = true;
      this.disableTemplateSelection = true;
    } else {
      this.fromModel = false;
      this.usingOneSpanSignatureModel = false;
      if (this.contract?.token) {
        this.disableTemplateSelection = true;
      } else {
        this.disableTemplateSelection = false;
      }
    }
  },

  mounted() {},

  computed: {},

  methods: {
    contractSelected(contract) {
      this.usingOneSpanSignatureModel = contract.token != null;
      this.contract.model_id = contract.id;
      this.contract.name = contract.name;
      this.contract.excerpt = contract.excerpt;
      this.contract.roles = contract.roles ?? [];
      this.contract.email_message = contract.email_message;
    },

    openOrCloseModelSelector() {
      this.usingOneSpanSignatureModel = false;
      this.contract.name = "";
      this.contract.excerpt = "";
      this.contract.email_message = "";
      this.contract.model_id = null;
      this.contract.roles = [];
    },

    async handleSubmit() {
      const checkUniqueContract = await this.checkContractUniqueInformation();
      if (checkUniqueContract) {
        await this.sendInformation();
      } else {
        this.showContractCheckModal = true;
      }
    },

    async sendInformation() {
      if (this.contract.name) {
        this.contract.name = this.contract.name.toString();
      }
      let contractData = cloneDeep(this.contract);
      contractData = this.$fillUserOrganizationData(contractData);
      this.$emit("contractSubmitted", contractData);
    },

    cancelEdition() {
      this.$emit("cancelEdition");
    },

    onFormChanged() {
      this.$emit("formChanged");
    },

    async getList() {
      if (!this.contract?.name) {
        return;
      }
      try {
        this.processing = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...{
              search: `${this.contract?.name}`,
            },
          },
          page: {
            number: 1,
            size: 999,
          },
        };
        await this.$store.dispatch("contracts/list", params);
        this.contracts = this.$store.getters["contracts/list"];
        this.total = this.$store.getters["contracts/listTotal"];
        this.processing = false;
      } catch (error) {
        this.processing = false;
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async checkContractUniqueInformation() {
      await this.getList();
      switch (this.total) {
        case 0:
          return true;
        case 1:
          return !!this.contract?.id;
        default:
          return false;
      }
    },

    async continueFormSubmitProcess() {
      this.processing = true;
      await this.toggleContractCheckModalState();
      await this.sendInformation();
      this.processing = false;
    },

    async toggleContractCheckModalState() {
      this.showContractCheckModal = !this.showContractCheckModal;
    },

    checkContractInformation() {
      this.$refs["contractForm"].validate(async (valid) => {
        if (valid) {
          if (this.contract.name) {
            this.handleSubmit();
            this.showModal = false;
          } else {
            this.showModal = true;
          }
        }
      });
    },

    async toggleModalState() {
      this.showModal = !this.showModal;
    },
  },

  watch: {
    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
    contractData(contractData) {
      if (contractData) {
        this.contract = {
          ...this.contract,
          ...cloneDeep(contractData),
        };
      }
    },
  },
};
</script>

<style>
.add-form .btn-cancel {
  font-size: 14px;
  min-height: 40px;
  border-radius: 8px;
  padding: 0 15px;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  color: #fff;
}

.add-form .el-input__inner,
.add-form .el-textarea {
  background-color: transparent;
  border-radius: 8px;
  color: #000;
}

.add-form .el-input__inner {
  min-height: 48px;
  border-color: #c8c8c8;
}

.form-group-wrapper-item .el-select {
  width: 100%;
}

.form-group-wrapper-item label {
  margin-bottom: 0.1rem !important;
}

.form-group-wrapper-item .el-form-item__label {
  padding: 0 0 1px !important;
}
</style>
